import type { Crumb } from '../layouts/section-trail';
import { Breadcrumbs } from './Breadcrumbs';
import { Skeleton } from './Skeleton';
import { SkeletonFields } from './SkeletonFields';
import { SkeletonRegion } from './SkeletonRegion';

interface DetailPageSkeletonProps {
  label: string;
  /** Known before the record loads, so shown for real above the title's placeholder. */
  breadcrumbs?: Crumb[];
  tabs?: number;
  fields?: number;
}

/** A record's own page before it loads: the `<PageHeader>` (title unknown yet), the tab strip and the details form in its two-column grid. */
export function DetailPageSkeleton({ label, breadcrumbs, tabs = 2, fields = 8 }: DetailPageSkeletonProps) {
  return (
    <SkeletonRegion label={label}>
      <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
        <div className="flex flex-col gap-2.5">
          {breadcrumbs ? <Breadcrumbs trail={breadcrumbs} /> : <Skeleton className="h-3 w-16" />}
          <Skeleton className="h-7 w-56 max-w-full" />
          <Skeleton className="h-4 w-40" />
        </div>
        <Skeleton className="h-6 w-24" />
      </div>
      <div className="mb-6 flex gap-8 border-b border-line pb-3">
        {Array.from({ length: tabs }, (_, index) => (
          <Skeleton key={index} className="h-4 w-16" />
        ))}
      </div>
      <SkeletonFields count={fields} columns={2} />
    </SkeletonRegion>
  );
}
